export default function Terms() {
  return (
    <div className="max-w-3xl mx-auto px-6 md:px-12 py-16 md:py-24" data-testid="terms-page">
      <p className="overline mb-3">Legal</p>
      <h1 className="font-serif-display text-4xl md:text-5xl tracking-tight mb-3">Terms of Service</h1>
      <p className="text-xs text-[#8C857B] mb-10">Last updated: February 2026</p>

      <div className="space-y-8 text-[#3a3733] text-sm md:text-base leading-relaxed">
        <section>
          <h2 className="font-serif-display text-2xl mb-3">1. Acceptance</h2>
          <p>
            By creating an account on Sanyog Vivah ("we", "us"), you agree to these Terms of Service and our
            Privacy Policy. If you do not agree, please do not use this service.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl mb-3">2. Eligibility</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>You must be at least 18 years of age (or the legal age of marriage in your state).</li>
            <li>You must be legally free to marry (unmarried, divorced, or widowed).</li>
            <li>Providing false information about marital status is prohibited and may lead to account termination.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl mb-3">3. Your Account</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>You must provide accurate, current, and complete information.</li>
            <li>You are responsible for keeping your password secure.</li>
            <li>You must not create multiple accounts or impersonate others.</li>
            <li>You must not use the service to solicit prostitution, sell products, or promote unrelated services.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl mb-3">4. Content Standards</h2>
          <p>You are prohibited from posting or sharing content that is:</p>
          <ul className="list-disc pl-6 space-y-2 mt-2">
            <li>Nude, sexually explicit, or suggestive imagery.</li>
            <li>Photos of children or minors.</li>
            <li>False, misleading, or fraudulent (fake profiles).</li>
            <li>Harassing, threatening, casteist, or hateful.</li>
            <li>Requests for money, gifts, or financial favors.</li>
            <li>External links, phone numbers, or social handles used to divert users off-platform.</li>
          </ul>
          <p className="mt-3">Violation may result in immediate account suspension or permanent ban without refund.</p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl mb-3">5. Conduct with Other Users</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Respect other members. No harassment, stalking, or discrimination.</li>
            <li>Chat only opens after mutual interest — do not send unsolicited messages.</li>
            <li>Use the Report feature for suspicious profiles instead of engaging.</li>
            <li>Do not share other users' photos, messages, or personal information outside Sanyog.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl mb-3">6. Premium Subscription</h2>
          <ul className="list-disc pl-6 space-y-2">
            <li>Premium is a paid tier granting AI compatibility, verified badge, priority listing, and unlimited interests.</li>
            <li>Payments processed via Stripe or Razorpay in INR (or applicable currency).</li>
            <li>Subscriptions are for the duration specified (monthly / annual).</li>
            <li><strong>Refund policy:</strong> No refunds for partial months. Full refund available within 7 days of first payment if no matches were sent/received.</li>
            <li>To cancel, email <strong>support@sanyogvivah.in</strong>.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl mb-3">7. AI Match Scoring</h2>
          <p>
            Our AI compatibility scoring is a supportive tool, not a guarantee of successful marriage.
            Scores are based on profile data and public preferences. Final decisions are yours.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl mb-3">8. Marriage Outcomes</h2>
          <p>
            Sanyog Vivah is an introduction platform. We do not guarantee marriage or long-term success.
            Users are responsible for verifying information (background, credentials, family) independently
            before commitment. Meeting in person: always in safe, public places.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl mb-3">9. Termination</h2>
          <p>
            We may suspend or terminate your account if you violate these Terms. You may delete your
            account at any time from the Settings page or by emailing support.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl mb-3">10. Limitation of Liability</h2>
          <p>
            Sanyog Vivah is not liable for any indirect, incidental, or consequential damages arising
            from use of the service. Our maximum liability is limited to the amount you paid us in the
            past 12 months.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl mb-3">11. Governing Law</h2>
          <p>
            These Terms are governed by the laws of India. Any dispute shall be subject to the exclusive
            jurisdiction of courts in [Your City], Maharashtra, India.
          </p>
        </section>

        <section>
          <h2 className="font-serif-display text-2xl mb-3">12. Contact</h2>
          <p>
            Questions? Email <a href="mailto:support@sanyogvivah.in" className="text-[#C85A44] hover:underline">support@sanyogvivah.in</a>
          </p>
        </section>
      </div>
    </div>
  );
}
